const OPTIONS = [
  { id: 'kette', label: 'Maßkette' },
  { id: 'skizze', label: 'Skizze' },
  { id: 'beides', label: 'Beides' },
];

// Umschalter Maßkette | Skizze | Beides (C7), Optik wie der
// Skalierungs-Umschalter in der Maßkette.
export default function ViewSwitch({ value, onChange }) {
  return (
    <div
      role="tablist"
      aria-label="Ansicht"
      className="bg-surface border border-line inline-flex"
      style={{ borderRadius: 'var(--radius-md)', padding: 2, alignSelf: 'center' }}
    >
      {OPTIONS.map((o) => {
        const active = value === o.id;
        return (
          <button
            key={o.id}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(o.id)}
            className={active ? 'bg-page text-brand' : 'text-ink-3'}
            style={{
              height: 24, padding: '0 10px', border: 'none',
              background: active ? 'var(--color-page)' : 'transparent',
              fontSize: 11, fontWeight: active ? 600 : 500,
              borderRadius: 6, cursor: 'pointer',
            }}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
